import {useApiRead} from '../../../../hooks/useApiRead';
import {useApiWrite} from '../../../../hooks/useApiWrite';
import {GetRoutes} from '../../../../lib/api/GET/GetRoutes';
import {Post} from '../../../../lib/api/POST/Post';
import {PostRoutes} from '../../../../lib/api/POST/PostRoutes';
import {ApplicantSkillsRequestBody} from '../../../../lib/api/RequestBodies/features/applicant/profile/ApplicantSkillsRequestBodies';
import {ApplicantSkill} from '../../../../types/applicantSkill/ApplicantSkill';
import {SkillExperience} from '../../../../types/shared-types';

interface Params {
  onUpdateSuccess?: () => void;
  onUpdateError?: () => void;
}

export const useApplicantSkills = ({onUpdateSuccess, onUpdateError}: Params) => {
  const {
    isPending,
    isLoading,
    data: applicantSkills,
    refetch,
  } = useApiRead<ApplicantSkill[]>({path: GetRoutes.applicantSkills});
  const onError = () => {
    if (onUpdateError) {
      onUpdateError();
    }
  };

  const onSuccess = () => {
    refetch();
    if (onUpdateSuccess) {
      onUpdateSuccess();
    }
  };

  const {makeRequest} = useApiWrite<Post.CreateApplicantSkills>({
    method: 'post',
    path: PostRoutes[Post.CreateApplicantSkills],
    onError,
    onSuccess,
  });

  const createApplicantSkills = (data: {skills: SkillExperience[]}) => {
    const payload: ApplicantSkillsRequestBody = {
      skills: data.skills.map((skill) => ({
        standardSkillId: skill.id as string,
      })),
    };

    makeRequest(payload);
  };

  return {
    applicantSkills,
    isLoading,
    isPending,
    createApplicantSkills,
  };
};
